import { useEffect, useState } from "react";
import axios from "axios";
import { useNavigate, useSearchParams, Link } from "react-router-dom";
import { API } from "../App";

export default function PaymentSuccess({ lang }) {
  const [params] = useSearchParams();
  const nav = useNavigate();
  const [status, setStatus] = useState("checking");
  const sessionId = params.get("session_id");
  const resultId = params.get("result_id");

  useEffect(() => {
    if (!sessionId || !resultId) return;
    let attempts = 0;
    const poll = async () => {
      attempts += 1;
      try {
        const r = await axios.get(`${API}/payments/status/${sessionId}`);
        if (r.data.payment_status === "paid") {
          setStatus("paid");
          setTimeout(() => nav(`/plan/${resultId}`), 800);
          return;
        }
        if (r.data.payment_status === "failed" || r.data.payment_status === "expired") {
          setStatus("failed");
          return;
        }
      } catch {}
      if (attempts < 20) setTimeout(poll, 1500);
      else setStatus("failed");
    };
    poll();
  }, [sessionId, resultId, nav]);

  const t = {
    en: {
      checking: "Confirming your payment…",
      paid: "Payment received. Opening your plan…",
      failed: "We couldn't confirm your payment. Please try again.",
      back: "Back to my results",
    },
    it: {
      checking: "Stiamo confermando il pagamento…",
      paid: "Pagamento ricevuto. Sto aprendo il tuo piano…",
      failed: "Non siamo riusciti a confermare il pagamento. Riprova.",
      back: "Torna ai risultati",
    },
  }[lang] || {};

  return (
    <div className="min-h-screen flex items-center justify-center p-6 bg-white" data-testid="payment-success-page">
      <div className="max-w-md text-center">
        <div className="text-[10px] kt-tracking-wider uppercase text-[#6F6B66] mb-3">KT Milano</div>
        <h1 className="font-serif text-3xl text-[#383633] tracking-tight mb-6" data-testid="payment-status">
          {status === "paid" ? t.paid : status === "failed" ? t.failed : t.checking}
        </h1>
        {status === "failed" && resultId && (
          <Link
            to={`/results/${resultId}`}
            data-testid="back-to-results"
            className="inline-flex items-center gap-3 rounded-full bg-[#383633] text-white px-8 py-3 text-xs kt-tracking uppercase"
          >
            {t.back}
          </Link>
        )}
      </div>
    </div>
  );
}
